<template>
  <div class="hello">
      <div class="container margin_60_35">
          <div class="row">
          <profileNav/>
          <MyOrder/>
          </div>
      </div>
  </div>  
</template>

<script>
import MyOrder from "@/components/MyOrder.vue";
import profileNav from './profile_nav'
export default {
  name: 'Userprofile',
  components:{
    MyOrder,
    profileNav
  },
}
</script>
<style>
 
</style>
